import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Carousel, Col } from "antd";
import Signup from "../../Components/Signup";
import "../../Stylesheet/carrier.scss";
// import Customersignup from '../../Images/Customersignup.png';

class customerSignup extends Component {
  render() {
    return (
      <div style={{ maxHeight: "100px" }}>
        <Row gutter={10}>
          <Col xs={0} sm={0} md={0} lg={12} className="HomeSlider">
            <Carousel autoplay></Carousel>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} className="homeSection">
            <Signup registrationType="customer" />
          </Col>
        </Row>
      </div>
    );
  }
}

export default customerSignup;
